import { render, staticRenderFns } from "./CaseTicket.vue?vue&type=template&id=704e6d7e&scoped=true&"
import script from "./CaseTicket.vue?vue&type=script&lang=js&"
export * from "./CaseTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e6d7e",
  null
  
)

export default component.exports